/* RESPONSIBLE TEAM: team-inbox-management */
import { isEmpty } from '@ember/utils';

let orderNameRegex = /^#?[a-zA-Z0-9]*[0-9][a-zA-Z0-9]*$/;

export function isValidOrderName(orderName) {
  return isEmpty(orderName) ? false : orderNameRegex.test(orderName);
}
